var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-settings"},[_c('mk-button-biz',{staticClass:"auth-settings-btn",attrs:{"type":"text","with":"300px"},on:{"click":_vm.handleSkipUrlClick}},[_vm._v("\n    点击跳转权限设置\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }